import React, { Component } from "react";
import { connect } from "react-redux";
import {
  List,
  Loader,
  Dimmer,
  Segment,
  Header,
  Message,
} from "semantic-ui-react";
import { lastTenResults } from "../../actions/auth";
import LastResultItem from "./Items/LastResultItem";

class LastResultList extends Component {
  state = {};

  componentDidMount() {
    //Motato Luis se agrega parametro user con el cual se valida para saber si se traen todo los registro
    this.props.lastTenResults(this.props.institucion, this.props.user);
  }

  render() {
    const { listReady, lastResults } = this.props;
    let lastTen = [];
    if (listReady) {
      lastTen = lastResults.map((patient) => {
        return (
          <LastResultItem
            patient={patient}
            key={patient.orden}
            showPatientOrderResults={this.props.showPatientOrderResults}
          />
        );
      });
    }
    return (
      <div>
        {!listReady ? (
          <Dimmer active inverted>
            <Loader>Cargando...</Loader>
          </Dimmer>
        ) : (
          <div>
            {lastResults.length === 0 ? (
              <Message
                info
                icon="info"
                header="Aún no tiene resultados asociados a su perfil."
              />
            ) : (
              <Segment>
                <Header as="h1">Resultados recientes</Header>
                <List divided verticalAlign="middle" size="large">
                  {lastTen}
                </List>
              </Segment>
            )}
          </div>
        )}
      </div>
    );
  }
}

// Motato Luis se agrega el parametro  user con el cual se valida si es super usuario
const mapStateToProps = (state) => {
  if (state.practitioner.resp.entityUser) {
    return {
      institucion: state.practitioner.resp.institucion,
      lastResults: state.lastTenResults.results,
      listReady: !!state.lastTenResults.results,
      user: state.practitioner.resp.super_usuario,
    };
  }
  return {
    institucion: state.practitioner.resp.fullname,
    lastResults: state.lastTenResults.results,
    listReady: !!state.lastTenResults.results,
    user: state.practitioner.resp.super_usuario,
  };
};


export default connect(mapStateToProps, {  lastTenResults })(LastResultList)
